import { Action } from '@ngrx/store'
import { PageStatus } from '../models/page-status'

export const SET = '[Status] Set Status'
export const APPLY = '[Status] Apply Status'
export const REAPPLY = '[Status] Reapply'
export const APPLYSUCCESS = '[Status] Apply Success'

export const SETSEARCHTERM = '[Status] Set search term'

export const SETHEADER = '[Status] Set header'

export class Set implements Action {
  readonly type = SET
}
export class Apply implements Action {
    readonly type = APPLY
}
export class Reapply implements Action {
  readonly type = REAPPLY
}
export class ApplySuccess implements Action {
  readonly type = APPLYSUCCESS
  constructor (public payload: PageStatus) { }
}
export class SetSearchTerm implements Action {
  readonly type = SETSEARCHTERM
  constructor(public payload: string) {}
}
export class SetHeader implements Action {
  readonly type = SETHEADER
  constructor(public payload: boolean) {}
}

export type Actions =
  Set
  | Apply
  | Reapply
  | ApplySuccess
  | SetSearchTerm
  | SetHeader
